import { render, staticRenderFns } from "./chanhou.vue?vue&type=template&id=39d52688&"
import script from "./chanhou.vue?vue&type=script&lang=ts&"
export * from "./chanhou.vue?vue&type=script&lang=ts&"
import style0 from "./chanhou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports